import React from 'react'
import { useNavigate } from 'react-router-dom'

type props = {
  path: string
}
const ViewMoreButton: React.FC<props> = ({ path }) => {
  const navigate = useNavigate()

  const handleViewMore = (path: string) => {
    navigate(path)
  }

  return (
    <button className="view-more-button" onClick={() => handleViewMore(path)}>
      View More
    </button>
  )
}

export default ViewMoreButton
